export const freshdeskViewSample = {
'freshdesk_webhook': {
        'ticket_id': 1,
        'ticket_subject': '[AlertNow Freshdesk] Test Incident#01',
        'ticket_description': '<div style=\'font-family:-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif; font-size:14px\'><div>Test Incident</div></div>',
        'ticket_url': 'https://test.freshdesk.com/helpdesk/tickets/1',
        'ticket_portal_url': 'https://test.freshdesk.com/support/tickets/1',
        'ticket_tags': 'AN',
        'ticket_latest_public_comment': null,
        'ticket_latest_private_comment': null,
        'ticket_group_name': 'Customer Support',
        'ticket_agent_name': null,
        'ticket_agent_email': null,
        'ticket_due_by_time': 'January 12 2022 at 05:00 PM EST',
        'ticket_satisfaction_survey': '',
        'ticket_status': 'Open',
        'ticket_priority': 'Low',
        'ticket_source': 'Phone',
        'ticket_ticket_type': 'Incident',
        'helpdesk_name': 'AlertNow',
        'triggered_event': '{ticket_action:created}',
        'ticket_company_name': null,
        'ticket_company_description': null,
        'ticket_company_note': null,
        'ticket_company_domains': null,
        'ticket_contact_name': 'Test Name',
        'ticket_contact_firstname': 'Test',
        'ticket_contact_lastname': 'Test Name',
        'ticket_contact_mobile': null,
        'ticket_contact_email': 'test@test.com',
        'ticket_contact_phone': null,
        'ticket_contact_address': ''
    }
};

export const freshdeskSample = {
    'freshdesk_webhook.ticket_id': 1,
    'freshdesk_webhook.ticket_subject': '[AlertNow Freshdesk] Test Incident#01',
    'freshdesk_webhook.ticket_description': '<div style=\'font-family:-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif; font-size:14px\'><div>Test Incident</div></div>',
    'freshdesk_webhook.ticket_url': 'https://test.freshdesk.com/helpdesk/tickets/1',
    'freshdesk_webhook.ticket_portal_url': 'https://test.freshdesk.com/support/tickets/1',
    'freshdesk_webhook.ticket_tags': 'AN',
    'freshdesk_webhook.ticket_latest_public_comment': null,
    'freshdesk_webhook.ticket_latest_private_comment': null,
    'freshdesk_webhook.ticket_group_name': 'Customer Support',
    'freshdesk_webhook.ticket_agent_name': null,
    'freshdesk_webhook.ticket_agent_email': null,
    'freshdesk_webhook.ticket_due_by_time': 'January 12 2022 at 05:00 PM EST',
    'freshdesk_webhook.ticket_satisfaction_survey': '',
    'freshdesk_webhook.ticket_status': 'Open',
    'freshdesk_webhook.ticket_priority': 'Low',
    'freshdesk_webhook.ticket_source': 'Phone',
    'freshdesk_webhook.ticket_ticket_type': 'Incident',
    'freshdesk_webhook.helpdesk_name': 'AlertNow',
    'freshdesk_webhook.triggered_event': '{ticket_action:created}',
    'freshdesk_webhook.ticket_company_name': null,
    'freshdesk_webhook.ticket_company_description': null,
    'freshdesk_webhook.ticket_company_note': null,
    'freshdesk_webhook.ticket_company_domains': null,
    'freshdesk_webhook.ticket_contact_name': 'Test Name',
    'freshdesk_webhook.ticket_contact_firstname': 'Test',
    'freshdesk_webhook.ticket_contact_lastname': 'Test Name',
    'freshdesk_webhook.ticket_contact_mobile': null,
    'freshdesk_webhook.ticket_contact_email': 'test@test.com',
    'freshdesk_webhook.ticket_contact_phone': null,
    'freshdesk_webhook.ticket_contact_address': ''
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/freshdesk.ts